<template>
  <div class="step-basic-editor">
    <el-form :model="localStep" :size="size" label-width="160px">
      <el-form-item label="步骤ID">
        <el-input v-model="localStep.stepId" disabled></el-input>
      </el-form-item>
      <el-form-item label="步骤名称">
        <el-input v-model="localStep.stepName" placeholder="请输入步骤名称"
          @input="updateField('stepName', $event)"></el-input>
      </el-form-item>
      <el-form-item label="是否动作步骤">
        <el-switch :value="localStep.actionStep" @change="updateField('actionStep', $event)" active-text="是"
          inactive-text="否"></el-switch>
      </el-form-item>

      <el-form-item v-if="!isActionStep" label="系统回复模板">
        <el-input v-model="localStep.replyTemplate" type="textarea" :rows="3" placeholder="请输入回复模板，可使用变量如 ${TIME}"
          @input="updateField('replyTemplate', $event)"></el-input>
      </el-form-item>

      <el-form-item v-if="!isActionStep" label="图片">
        <multiple-file-upload v-model="localStep.replyPhotos" :filePath="ossProblemFlowImagePath" :ossBucket="ossBucket"
          :simpleData="true" />
      </el-form-item>

      <el-form-item v-if="!isActionStep" label="下一步处理人">
        <el-select :value="localStep.nextHandleRole" @change="updateField('nextHandleRole', $event)"
          placeholder="请选择下一步处理人" style="width: 100%">
          <el-option v-for="option in msgRoleOptions" :key="option.value" :label="option.label || option.value"
            :value="option.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isActionStep" label="下一步允许的任务">
        <el-select :value="localStep.nextAllowedComTasks" @change="handleNextAllowedComTasksChange" multiple clearable
          placeholder="请选择下一步允许的任务" style="width: 100%">
          <el-option v-for="option in commonTaskTypeOptions" :key="option.value" :label="option.label || option.value"
            :value="option.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isActionStep && showNextAllowedSpecTasks" label="下一步允许的特殊任务">
        <el-select :value="localStep.nextAllowedSpecTasks" @change="updateField('nextAllowedSpecTasks', $event)"
          multiple clearable placeholder="请选择允许的特殊任务" style="width: 100%">
          <el-option v-for="option in specTaskTypeOptions" :key="option.value" :label="option.label || option.value"
            :value="option.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isActionStep" label="默认下一步">
        <el-select :value="localStep.defaultNextStepId" @change="updateField('defaultNextStepId', $event)" filterable
          placeholder="请选择默认下一步" clearable style="width: 100%">
          <el-option v-for="step in stepOptions" :key="step.stepId" :label="step.label"
            :value="step.stepId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "StepBasicEditor",
  props: {
    stepId: {
      type: String,
      required: true
    }
  },
  inject: {
    getEditingStepData: {
      from: "getEditingStepData",
      default: () => () => null
    },
    updateEditingStepField: {
      from: "updateEditingStepField",
      default: () => () => { }
    }
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize
    }),
    ...mapGetters("problemFlowConfig", [
      "steps",
      "stepIds",
      "stepOptions",
      "problemStatusOptions",
      "commonTaskTypeOptions",
      "specTaskTypeOptions",
      "msgRoleOptions"
    ]),
    localStep() {
      // 优先使用临时编辑状态，否则使用 store 中的数据
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        return editingStepData;
      }
      return this.steps[this.stepId] || {};
    },
    allStepIds() {
      return this.stepIds;
    },
    isActionStep() {
      return this.localStep.actionStep === true;
    },
    nextRoleIsDriver() {
      return this.localStep.nextHandleRole === "DRIVER";
    },
    showNextAllowedSpecTasks() {
      // 只有当nextAllowedComTasks包含SPECIAL_TASK时，才显示nextAllowedSpecTasks
      const nextAllowedComTasks = this.localStep.nextAllowedComTasks || [];
      return Array.isArray(nextAllowedComTasks) && nextAllowedComTasks.includes("SPECIAL_TASK");
    }
  },

  data() {
    return {
      ossProblemFlowImagePath: "/problem/flow/images",
      ossBucket: "yxmgt-private"
    };
  },
  methods: {
    updateField(field, value) {
      // 空字符串转为null
      const _value = value && value.trim && value.trim() === "" ? null : value;

      // 优先更新临时编辑状态，否则直接更新 store
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        this.updateEditingStepField(field, _value);

        // 如果设置为动作步骤，清空不需要的字段
        if (field === "actionStep" && _value === true) {
          this.updateEditingStepField("replyTemplate", null);
          this.updateEditingStepField("problemStatus", null);
          this.updateEditingStepField("nextAllowedComTasks", null);
          this.updateEditingStepField("nextAllowedSpecTasks", null);
          this.updateEditingStepField("dealResult", null);
          this.updateEditingStepField("defaultNextStepId", null);
        }
      } else {
        this.$store.dispatch("problemFlowConfig/updateStepField", {
          stepId: this.stepId,
          field,
          value: _value
        });

        // 如果设置为动作步骤，清空不需要的字段
        if (field === "actionStep" && _value === true) {
          const fieldsToClear = [
            "replyTemplate",
            "problemStatus",
            "nextAllowedComTasks",
            "nextAllowedSpecTasks",
            "dealResult",
            "defaultNextStepId"
          ];
          fieldsToClear.forEach((f) => {
            this.$store.dispatch("problemFlowConfig/updateStepField", {
              stepId: this.stepId,
              field: f,
              value: null
            });
          });
        }
      }
    },
    handleNextAllowedComTasksChange(value) {
      // 更新nextAllowedComTasks
      this.updateField("nextAllowedComTasks", value);

      // 如果nextAllowedComTasks不包含SPECIAL_TASK，清空nextAllowedSpecTasks
      if (!Array.isArray(value) || !value.includes("SPECIAL_TASK")) {
        this.updateField("nextAllowedSpecTasks", null);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.step-basic-editor {
  padding: 10px;
}
</style>
